import React, { useEffect } from "react";
export const InvoicePrint = ({ dependencies }) => {
  const { renderCycleID: id } = dependencies;
  useEffect(
    () => id && sessionStorage.setItem("invoice-print-render-cycle-id", id),
    [id]
  );
  if (!dependencies) return "";

  const {
    invoice_setup,
    order_json = [],
    seat_name,
    section_name,
    user_title,
    paymentMode,
    itemsDetails,
    kotItemDetails,
    couponsMessages,
    dateFormat = sessionStorage.getItem("date_format"),
  } = dependencies;

  const orderDate = new Date(+order_json?.created_at || order_json?.created_at);
  const bottomNote = invoice_setup?.field_values?.invoice_bottomnote;

  return (
    <>
      <div>
        {order_json?.brand_uuid && <img
          src={`https://api.myfooddo.com/logos/${order_json?.brand_uuid}.jpeg`}
          alt="logo"
          style={{ maxWidth: "100%", maxHeight: "125px", objectFit: "cover" }}
        ></img>}
      </div>
      <table style={{ width: "100%" }}>
        <tr>
          <td style={{ textAlign: "center", fontSize: "large" }}>
            {invoice_setup?.field_values?.invoice_heading}
          </td>
        </tr>
        <tr>
          <td
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "x-large",
            }}
          >
            {invoice_setup?.field_values?.invoice_title}
          </td>
        </tr>
        {invoice_setup?.field_values?.invoice_address
          ?.split("\n")
          ?.map(function (item, idx) {
            return (
              <tr key={Math?.random()}>
                <td style={{ textAlign: "center", fontSize: "large" }}>
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                </td>
              </tr>
            );
          })}
        {invoice_setup?.field_values?.invoice_phone
          ?.split("\n")
          ?.map((item) => (
            <tr>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "large",
                }}
              >
                {item}
              </td>
            </tr>
          ))}
      </table>
      <table style={{ width: "100%", borderBottom: "1px solid black" }}>
        {invoice_setup?.field_values?.invoice_blank !== "" &&
          invoice_setup?.field_values?.invoice_blank
            ?.split("\n")
            ?.map(function (item, idx) {
              return (
                <tr key={Math?.random()}>
                  <td style={{ textAlign: "center", fontSize: "large" }}>
                    <span key={idx}>
                      {item}
                      <br />
                    </span>
                  </td>
                </tr>
              );
            })}
      </table>
      <div>
        {+invoice_setup?.invoice_field_customization?.seat === 1 && (
          <div
            style={{
              float: "left",
              width: "60%",
              fontSize: "large",
            }}
          >
            At:{" "}
            {+order_json?.order_type === 1
              ? "Take Away"
              : +order_json?.order_type === 2
                ? "Delivery"
                : +order_json?.order_type === 3
                  ? "Zomato"
                  : +order_json?.order_type === 4
                    ? "Swiggy"
                    : +order_json?.order_type === 5
                      ? "Meals"
                      : `${seat_name} - ${section_name}`}
          </div>
        )}
        {+invoice_setup?.invoice_field_customization?.ticket_number === 1 && (
          <div
            style={{
              float: "left",
              width: "40%",
              fontSize: "large",
            }}
          >
            KOT: [
            {order_json?.order_kot_details?.map((item, i) => {
              if (order_json?.order_kot_details?.length === i + 1) {
                return item?.kot;
              } else if (i % 3 === 0) {
                return (
                  <>
                    <br />
                    {item?.kot},
                  </>
                );
              }
              return `${item?.kot},`;
            })}
            ]
          </div>
        )}
        {+invoice_setup?.invoice_field_customization?.order_number === 1 && (
          <div
            style={{
              float: "left",
              width: "60%",
              fontSize: "large",
            }}
          >
            Order No. : {order_json?.local_order_id}
          </div>
        )}
        {(+invoice_setup?.invoice_field_customization?.payment_mode === 1 ||
          +invoice_setup?.invoice_field_customization?.cashier === 1) && (
            <div
              style={{
                float: "right",
                width: "40%",
                fontSize: "large",
              }}
            >
              Payment :{" "}
              {order_json?.payment_status !== 0
                ? +invoice_setup?.invoice_field_customization?.cashier === 1 &&
                user_title
                : "Unpaid"}
              {+invoice_setup?.invoice_field_customization?.payment_mode === 1 &&
                +invoice_setup?.invoice_field_customization?.cashier === 1 &&
                order_json?.payment_status !== 0 &&
                " - "}
              {+invoice_setup?.invoice_field_customization?.payment_mode === 1 &&
                order_json?.payment_status !== 0
                ? order_json?.payment_details?.length === 1 &&
                  Array.isArray(paymentMode)
                  ? paymentMode?.filter(
                    (item) =>
                      item?.payment_mode_uuid ===
                      order_json?.payment_details[0]?.payment_mode_uuid
                  )[0]?.payment_mode_name
                  : "Multi"
                : ""}
            </div>
          )}
        {(+invoice_setup?.invoice_field_customization?.date === 1 ||
          +invoice_setup?.invoice_field_customization?.time === 1) && (
            <div
              style={{
                float: "left",
                width: "60%",
                fontSize: "large",
              }}
            >
              {+invoice_setup?.invoice_field_customization?.date === 1 &&
                order_json &&
                dateFormat
                  ?.replace(
                    "mm",
                    ("00" + (orderDate?.getMonth() + 1)?.toString())?.slice(-2)
                  )
                  ?.replace(
                    "yy",
                    ("0000" + orderDate?.getFullYear()?.toString())?.slice(-4)
                  )
                  ?.replace(
                    "dd",
                    ("00" + orderDate?.getDate()?.toString())?.slice(-2)
                  )}
              {+invoice_setup?.invoice_field_customization?.date === 1 &&
                +invoice_setup?.invoice_field_customization?.time === 1 &&
                "-"}
              {invoice_setup?.invoice_field_customization?.time &&
                ("00" + orderDate?.getHours()?.toString())?.slice(-2) +
                ":" +
                ("00" + orderDate?.getMinutes()?.toString())?.slice(-2)}
            </div>
          )}
      </div>

      <table
        style={{
          width: "100%",
          borderTop: "1px solid black",
          borderBottom: "1px solid black",
        }}
      >
        <tr>
          {+invoice_setup?.invoice_field_customization
            ?.serial_number_in_items === 1 && (
              <th
                style={{
                  fontSize: "large",
                  fontWeight: "bold",
                  textAlign: "left",
                  borderBottom: "1px dotted black",
                  width: "10%",
                }}
              >
                S.No
              </th>
            )}
          <th
            style={{
              fontSize: "large",
              fontWeight: "bold",
              borderBottom: "1px dotted black",
              textAlign: "left",
            }}
            colSpan={2}
          >
            Items
          </th>
          <th
            style={{
              fontSize: "large",
              fontWeight: "bold",
              borderBottom: "1px dotted black",
              textAlign: "left",
            }}
          >
            Qty
          </th>
          <th
            style={{
              fontSize: "large",
              fontWeight: "bold",
              borderBottom: "1px dotted black",
              textAlign: "left",
            }}
          >
            Rate
          </th>
          <th
            style={{
              fontSize: "large",
              fontWeight: "bold",
              borderBottom: "1px dotted black",
              textAlign: "left",
            }}
          >
            Amt
          </th>
        </tr>
        {invoice_setup?.invoice_field_customization?.item_display_type === 0 ? (
          <>
            {kotItemDetails
              ?.filter(
                (value, index, self) =>
                  +index ===
                  self?.findIndex(
                    (t) =>
                      t?.item_uuid === value?.item_uuid &&
                      !t?.addon_details?.length &&
                      !value?.multi_details?.length
                  )
              )
              ?.map((data, i) => {
                let quantity =
                  kotItemDetails?.filter(
                    (kotpriceItem) =>
                      kotpriceItem?.item_uuid === data?.item_uuid
                  )?.length > 1
                    ? kotItemDetails
                      ?.filter(
                        (kotpriceItem) =>
                          kotpriceItem?.item_uuid === data?.item_uuid
                      )
                      ?.map((a) => a?.order_item_qty)
                      ?.reduce((a, b) => a + b)
                    : data?.order_item_qty;
                return (
                  <tr key={Math?.random()}>
                    {invoice_setup?.invoice_field_customization
                      ?.serial_number_in_items === "1" && (
                        <td
                          style={{
                            fontSize: "large",
                            textAlign: "left",
                            width: "10%",
                          }}
                        >
                          {i + 1}
                          {` )`}
                        </td>
                      )}
                    <td style={{ fontSize: "large" }} colSpan={2}>
                      {itemsDetails?.find(
                        (itemdata) => itemdata?.item_uuid === data?.item_uuid
                      ) &&
                        itemsDetails?.find(
                          (itemdata) => itemdata?.item_uuid === data?.item_uuid
                        )?.item_name}
                    </td>
                    <td style={{ fontSize: "large" }}>{quantity}</td>

                    <td style={{ fontSize: "large" }}>
                      {data?.order_item_unit_price}
                    </td>
                    <td style={{ fontSize: "large" }}>
                      {quantity * data?.order_item_unit_price}
                      {data?.addon_details?.map((MultiDetails) => (
                        <>
                          <br />
                          {quantity * MultiDetails?.price}
                        </>
                      ))}
                      {data?.multi_details?.map((MultiDetails) => (
                        <>
                          <br />
                          {quantity * MultiDetails?.price}
                        </>
                      ))}
                    </td>
                  </tr>
                );
              })}
            {kotItemDetails
              ?.filter(
                (value, index) =>
                  value?.addon_details?.length || value?.multi_details?.length
              )
              ?.map((data, i) => (
                <tr key={Math?.random()}>
                  {invoice_setup?.invoice_field_customization
                    ?.serial_number_in_items === "1" && (
                      <td
                        style={{
                          fontSize: "large",
                          textAlign: "left",
                          width: "10%",
                        }}
                      >
                        {i + 1}
                        {` )`}
                      </td>
                    )}
                  <td style={{ fontSize: "large" }} colSpan={2}>
                    {itemsDetails?.find(
                      (itemdata) => itemdata?.item_uuid === data?.item_uuid
                    ) &&
                      itemsDetails?.find(
                        (itemdata) => itemdata?.item_uuid === data?.item_uuid
                      )?.item_name}
                    {data?.addon_details?.map((addonDetails) => (
                      <i key={Math?.random()}>
                        <br />-
                        {itemsDetails?.find(
                          (itemdata) =>
                            itemdata?.item_uuid === addonDetails?.item_uuid
                        ) &&
                          itemsDetails?.find(
                            (itemdata) =>
                              itemdata?.item_uuid === addonDetails?.item_uuid
                          )?.item_name}
                      </i>
                    ))}
                    {data?.multi_details?.map((MultiDetails) => (
                      <i key={Math?.random()}>
                        <br />+{MultiDetails?.name}
                      </i>
                    ))}
                  </td>
                  <td style={{ fontSize: "large" }}>{data?.order_item_qty}</td>

                  <td style={{ fontSize: "large" }}>
                    {data?.order_item_unit_price}
                    {data?.addon_details?.map((MultiDetails) => (
                      <>
                        <br />
                        {MultiDetails?.price}
                      </>
                    ))}
                    {data?.multi_details?.map((MultiDetails) => (
                      <>
                        <br />
                        {MultiDetails?.price}
                      </>
                    ))}
                  </td>
                  <td style={{ fontSize: "large" }}>
                    {data?.order_item_qty * data?.order_item_unit_price}
                    {data?.addon_details?.map((MultiDetails) => (
                      <>
                        <br />
                        {data?.order_item_qty * MultiDetails?.price}
                      </>
                    ))}
                    {data?.multi_details?.map((MultiDetails) => (
                      <>
                        <br />
                        {data?.order_item_qty * MultiDetails?.price}
                      </>
                    ))}
                  </td>
                </tr>
              ))}
          </>
        ) : +invoice_setup?.invoice_field_customization?.item_display_type ===
          2 ? (
          order_json?.order_kot_details?.map((item, i) => (
            <>
              <tr key={Math?.random()}>
                <td
                  style={{
                    fontStyle: "italic",
                    fontSize: "large",
                    textAlign: "center",
                  }}
                  colSpan="5"
                >
                  <u>{`${item?.kot} ${dateFormat
                    ?.replace(
                      "mm",
                      (
                        "00" +
                        (new Date(item?.created_at || +order_json.created_at)
                          ?.getMonth()
                          + 1)?.toString()
                      )?.slice(-2)
                    )
                    ?.replace(
                      "yy",
                      (
                        "0000" +
                        new Date(item?.created_at || +order_json.created_at)
                          ?.getFullYear()
                          ?.toString()
                      )?.slice(-4)
                    )
                    ?.replace(
                      "dd",
                      (
                        "00" +
                        new Date(item?.created_at || +order_json.created_at)
                          ?.getDate()
                          ?.toString()
                      )?.slice(-2)
                    )} ${(
                      "00" +
                      new Date(item?.created_at || +order_json.created_at)
                        ?.getHours()
                        ?.toString()
                    )?.slice(-2) +
                    ":" +
                    (
                      "00" +
                      new Date(item?.created_at || +order_json?.created_at)?.getMinutes()?.toString()
                    )?.slice(-2)
                    }`}</u>
                </td>
              </tr>
              {kotItemDetails
                ?.filter((item2) => item2?.kot === item?.kot)
                ?.map((data, ci) => (
                  <tr key={Math?.random()}>
                    {invoice_setup?.invoice_field_customization
                      ?.serial_number_in_items === "1" && (
                        <td
                          style={{
                            fontSize: "large",
                            textAlign: "left",
                            width: "10%",
                          }}
                        >
                          {ci + 1}
                          {` )`}
                        </td>
                      )}
                    <td style={{ fontSize: "large" }} colSpan={2}>
                      {itemsDetails?.find(
                        (itemdata) => itemdata?.item_uuid === data?.item_uuid
                      ) &&
                        itemsDetails?.find(
                          (itemdata) => itemdata?.item_uuid === data?.item_uuid
                        )?.item_name}
                      {data?.addon_details?.map((addonDetails) => (
                        <i key={Math?.random()}>
                          <br />-
                          {itemsDetails?.find(
                            (itemdata) =>
                              itemdata?.item_uuid === addonDetails?.item_uuid
                          ) &&
                            itemsDetails?.find(
                              (itemdata) =>
                                itemdata?.item_uuid === addonDetails?.item_uuid
                            )?.item_name}
                        </i>
                      ))}
                      {data?.multi_details?.map((MultiDetails) => (
                        <i key={Math?.random()}>
                          <br />+{MultiDetails?.name}
                        </i>
                      ))}
                    </td>
                    <td style={{ fontSize: "large" }}>
                      {data?.order_item_qty}
                    </td>

                    <td style={{ fontSize: "large" }}>
                      {data?.order_item_unit_price}
                      {data?.addon_details?.map((MultiDetails) => (
                        <>
                          <br />
                          {MultiDetails?.price}
                        </>
                      ))}
                      {data?.multi_details?.map((MultiDetails) => (
                        <>
                          <br />
                          {MultiDetails?.price}
                        </>
                      ))}
                    </td>
                    <td style={{ fontSize: "large" }}>
                      {data?.order_item_qty * data?.order_item_unit_price}
                      {data?.addon_details?.map((MultiDetails) => (
                        <>
                          <br />
                          {data?.order_item_qty * MultiDetails?.price}
                        </>
                      ))}
                      {data?.multi_details?.map((MultiDetails) => (
                        <>
                          <br />
                          {data?.order_item_qty * MultiDetails?.price}
                        </>
                      ))}
                    </td>
                  </tr>
                ))}
            </>
          ))
        ) : (
          kotItemDetails?.map((data, ci) => (
            <tr>
              {invoice_setup?.invoice_field_customization
                ?.serial_number_in_items === "1" && (
                  <td
                    style={{
                      fontSize: "large",
                      textAlign: "left",
                      width: "10%",
                    }}
                  >
                    {ci + 1}
                    {` )`}
                  </td>
                )}
              <td style={{ fontSize: "large" }} colSpan={2}>
                {itemsDetails?.find(
                  (itemdata) => itemdata?.item_uuid === data?.item_uuid
                ) &&
                  itemsDetails?.find(
                    (itemdata) => itemdata?.item_uuid === data?.item_uuid
                  )?.item_name}
                {data?.addon_details?.map((addonDetails) => (
                  <i key={Math?.random()}>
                    <br />-
                    {itemsDetails?.find(
                      (itemdata) =>
                        itemdata?.item_uuid === addonDetails?.item_uuid
                    ) &&
                      itemsDetails?.find(
                        (itemdata) =>
                          itemdata?.item_uuid === addonDetails?.item_uuid
                      )?.item_name}
                  </i>
                ))}
                {data?.multi_details?.map((MultiDetails) => (
                  <i key={Math?.random()}>
                    <br />+{MultiDetails?.name}
                  </i>
                ))}
              </td>
              <td style={{ fontSize: "large" }}>{data?.order_item_qty}</td>

              <td style={{ fontSize: "large" }}>
                {data?.order_item_unit_price}
                {data?.addon_details?.map((MultiDetails) => (
                  <>
                    <br />
                    {MultiDetails?.price}
                  </>
                ))}
                {data?.multi_details?.map((MultiDetails) => (
                  <>
                    <br />
                    {MultiDetails?.price}
                  </>
                ))}
              </td>
              <td style={{ fontSize: "large" }}>
                {data?.order_item_qty * data?.order_item_unit_price}
                {data?.addon_details?.map((MultiDetails) => (
                  <>
                    <br />
                    {data?.order_item_qty * MultiDetails?.price}
                  </>
                ))}
                {data?.multi_details?.map((MultiDetails) => (
                  <>
                    <br />
                    {data?.order_item_qty * MultiDetails?.price}
                  </>
                ))}
              </td>
            </tr>
          ))
        )}
      </table>
      <table style={{ width: "100%", borderBottom: "1px solid black" }}>
        <tr>
          <td style={{ width: "50%" }}>
            <table style={{ width: "100%" }}>
              <tr>
                <td style={{ width: "40%", fontSize: "large" }}>
                  {(+order_json?.order_type === 1 &&
                    ((+invoice_setup?.invoice_field_customization
                      ?.customer_name_dinein === 1 &&
                      order_json?.customer_name !== "") ||
                      (+invoice_setup?.invoice_field_customization
                        ?.customer_mobile_dinein === 1 &&
                        order_json?.customer_mobile !== "") ||
                      (+invoice_setup?.invoice_field_customization
                        ?.customer_address_dinein === 1 &&
                        order_json?.delivery_address !== ""))
                    ? "For: "
                    : +order_json?.order_type === 2 &&
                      ((+invoice_setup?.invoice_field_customization
                        ?.customer_name_takeaway === 1 &&
                        order_json?.customer_name !== "") ||
                        (+invoice_setup?.invoice_field_customization
                          ?.customer_mobile_takeaway === 1 &&
                          order_json?.customer_mobile !== "") ||
                        (+invoice_setup?.invoice_field_customization
                          ?.customer_address_takeaway === 1 &&
                          order_json?.delivery_address !== ""))
                      ? "For: "
                      : +order_json?.order_type === 3 &&
                        ((+invoice_setup?.invoice_field_customization
                          ?.customer_name_delivery === 1 &&
                          order_json?.customer_name !== "") ||
                          (+invoice_setup?.invoice_field_customization
                            ?.customer_mobile_delivery === 1 &&
                            order_json?.customer_mobile !== "") ||
                          (+invoice_setup?.invoice_field_customization
                            ?.customer_address_delivery === 1 &&
                            order_json?.delivery_address !== ""))
                        ? "For: "
                        : order_json?.order_type === 4 &&
                          ((invoice_setup?.invoice_field_customization
                            ?.customer_name_zomato === 1 &&
                            order_json?.customer_name !== "") ||
                            (invoice_setup?.invoice_field_customization
                              ?.customer_mobile_zomato === 1 &&
                              order_json?.customer_mobile !== "") ||
                            (invoice_setup?.invoice_field_customization
                              ?.customer_address_zomato === 1 &&
                              order_json?.delivery_address !== ""))
                          ? "For: "
                          : order_json?.order_type === 5 &&
                            ((invoice_setup?.invoice_field_customization
                              ?.customer_name_swiggy === 1 &&
                              order_json?.customer_name !== "") ||
                              (invoice_setup?.invoice_field_customization
                                ?.customer_mobile_swiggy === 1 &&
                                order_json?.customer_mobile !== "") ||
                              (invoice_setup?.invoice_field_customization
                                ?.customer_address_swiggy === 1 &&
                                order_json?.delivery_address !== ""))
                            ? "For: "
                            : +order_json?.order_type === 0 &&
                              ((+invoice_setup?.invoice_field_customization
                                ?.customer_name_meals === 1 &&
                                order_json?.customer_name !== "") ||
                                (+invoice_setup?.invoice_field_customization
                                  ?.customer_mobile_meals === 1 &&
                                  order_json?.customer_mobile !== "") ||
                                (+invoice_setup?.invoice_field_customization
                                  ?.customer_address_meals === 1 &&
                                  order_json?.delivery_address !== ""))
                              ? "For: "
                              : "") +
                    (+order_json?.order_type === 1
                      ? +invoice_setup?.invoice_field_customization
                        ?.customer_name_takeaway === 1
                        ? order_json?.customer_name
                        : ""
                      : +order_json?.order_type === 2
                        ? +invoice_setup?.invoice_field_customization
                          ?.customer_name_delivery === 1
                          ? order_json?.customer_name
                          : " "
                        : +order_json?.order_type === 3
                          ? +invoice_setup?.invoice_field_customization
                            ?.customer_name_zomato === 1
                            ? order_json?.customer_name
                            : " "
                          : +order_json?.order_type === 4
                            ? +invoice_setup?.invoice_field_customization
                              ?.customer_name_swiggy === 1
                              ? order_json?.customer_name
                              : " "
                            : +order_json?.order_type === 5
                              ? +invoice_setup?.invoice_field_customization
                                ?.customer_name_meals === 1
                                ? order_json?.customer_name
                                : " "
                              : +order_json?.order_type === 0
                                ? +invoice_setup?.invoice_field_customization
                                  ?.customer_name_dinein === 1
                                  ? order_json?.customer_name
                                  : " "
                                : "") +
                    (+order_json?.order_type === 1
                      ? +invoice_setup?.invoice_field_customization
                        ?.customer_mobile_takeaway === 1
                        ? (+invoice_setup?.invoice_field_customization
                          ?.customer_name_takeaway === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                          ? " - "
                          : " ") + order_json?.customer_mobile
                        : " "
                      : +order_json?.order_type === 2
                        ? +invoice_setup?.invoice_field_customization
                          ?.customer_mobile_delivery === 1
                          ? (+invoice_setup?.invoice_field_customization
                            ?.customer_name_delivery === 1 &&
                            order_json?.customer_name !== "" &&
                            order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                          : " "
                        : +order_json?.order_type === 3
                          ? +invoice_setup?.invoice_field_customization
                            ?.customer_mobile_zomato === 1
                            ? (+invoice_setup?.invoice_field_customization
                              ?.customer_name_zomato === 1 &&
                              order_json?.customer_name !== "" &&
                              order_json?.customer_mobile !== ""
                              ? " - "
                              : " ") + order_json?.customer_mobile
                            : " "
                          : +order_json?.order_type === 4
                            ? +invoice_setup?.invoice_field_customization
                              ?.customer_mobile_swiggy === 1
                              ? (+invoice_setup?.invoice_field_customization
                                ?.customer_name_swiggy === 1 &&
                                order_json?.customer_name !== "" &&
                                order_json?.customer_mobile !== ""
                                ? " - "
                                : " ") + order_json?.customer_mobile
                              : " "
                            : +order_json?.order_type === 5
                              ? +invoice_setup?.invoice_field_customization
                                ?.customer_mobile_meals === 1
                                ? (+invoice_setup?.invoice_field_customization
                                  ?.customer_name_meals === 1 &&
                                  order_json?.customer_name !== "" &&
                                  order_json?.customer_mobile !== ""
                                  ? " - "
                                  : " ") + order_json?.customer_mobile
                                : " "
                              : +order_json?.order_type === 0
                                ? +invoice_setup?.invoice_field_customization
                                  ?.customer_mobile_dinein === 1
                                  ? (+invoice_setup?.invoice_field_customization
                                    ?.customer_name_dinein === 1 &&
                                    order_json?.customer_name !== "" &&
                                    order_json?.customer_mobile !== ""
                                    ? " - "
                                    : " ") + order_json?.customer_mobile
                                  : " "
                                : "")}
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%", fontSize: "large" }}>
                  {+order_json?.order_type === 1
                    ? +invoice_setup?.invoice_field_customization
                      ?.customer_address_takeaway === 1 &&
                    order_json?.delivery_address?.replace("/n", "--")
                    : +order_json?.order_type === 2
                      ? +invoice_setup?.invoice_field_customization
                        ?.customer_address_delivery === 1 &&
                      order_json?.delivery_address?.replace("/n", "--")
                      : +order_json?.order_type === 3
                        ? +invoice_setup?.invoice_field_customization
                          ?.customer_address_zomato === 1 &&
                        order_json?.delivery_address?.replace("/n", "--")
                        : +order_json?.order_type === 4
                          ? +invoice_setup?.invoice_field_customization
                            ?.customer_address_swiggy === 1 &&
                          order_json?.delivery_address?.replace("/n", "--")
                          : +order_json?.order_type === 5
                            ? +invoice_setup?.invoice_field_customization
                              ?.customer_address_meals === 1 &&
                            order_json?.delivery_address?.replace("/n", "--")
                            : +order_json?.order_type === 0
                              ? +invoice_setup?.invoice_field_customization
                                ?.customer_address_dinein === 1 &&
                              order_json?.delivery_address?.replace("/n", "--")
                              : ""}
                </td>
              </tr>

              <tr>
                <td style={{ fontSize: "large", fontWeight: "bold" }}>
                  {invoice_setup?.invoice_field_customization
                    ?.total_item_quantity === 1
                    ? "Total Qty : " +
                    (kotItemDetails?.map((a) => a?.order_item_qty)?.length > 1
                      ? kotItemDetails
                        ?.map((a) => a?.order_item_qty)
                        ?.reduce((a, b) => parseInt(a) + parseInt(b))
                      : kotItemDetails[0]?.order_item_qty)
                    : ""}
                </td>
              </tr>
            </table>
          </td>
          <td style={{ width: "50%" }}>
            <table style={{ width: "100%" }}>
              <tr>
                <td style={{ fontSize: "large" }} colSpan={2}>
                  Sub Total:
                </td>
                <td style={{ fontSize: "large" }}>
                  {kotItemDetails?.length
                    ? kotItemDetails?.length > 1
                      ? kotItemDetails
                        ?.map((a) => {
                          let arr = [];
                          arr?.push(a?.order_item_unit_price);
                          if (a?.addon_details?.length) {
                            arr?.push(
                              a?.addon_details?.length > 1
                                ? a?.addon_details?.reduce(
                                  (c, d) =>
                                    parseInt(c?.price) + parseInt(d?.price)
                                )
                                : parseInt(a?.addon_details[0]?.price)
                            );
                          }

                          if (a?.multi_details?.length) {
                            arr?.push(
                              a?.multi_details?.length > 1
                                ? a?.multi_details?.reduce(
                                  (c, d) =>
                                    parseInt(c?.price) + parseInt(d?.price)
                                )
                                : parseInt(a?.multi_details[0]?.price)
                            );
                          }
                          if (arr?.length > 1) {
                            return (
                              arr?.reduce(
                                (a, b) => parseInt(a) + parseInt(b)
                              ) * a?.order_item_qty
                            );
                          } else {
                            return arr[0] * a?.order_item_qty;
                          }
                        })
                        ?.reduce((a, b) => a + b)
                      : (() => {
                        let arr = [];
                        arr?.push(kotItemDetails[0]?.order_item_unit_price);
                        if (kotItemDetails[0]?.addon_details?.length) {
                          arr?.push(
                            kotItemDetails[0]?.addon_details?.length > 1
                              ? kotItemDetails[0]?.addon_details?.reduce(
                                (c, d) =>
                                  parseInt(c?.price) + parseInt(d?.price)
                              )
                              : parseInt(
                                kotItemDetails[0]?.addon_details[0]?.price
                              )
                          );
                        }

                        if (kotItemDetails[0]?.multi_details?.length) {
                          arr?.push(
                            kotItemDetails[0]?.multi_details?.length > 1
                              ? kotItemDetails[0]?.multi_details?.reduce(
                                (c, d) =>
                                  parseInt(c?.price) + parseInt(d?.price)
                              )
                              : parseInt(
                                kotItemDetails[0]?.multi_details[0]?.price
                              )
                          );
                        }
                        if (arr?.length > 1) {
                          return (
                            arr?.reduce((a, b) => parseInt(a) + parseInt(b)) *
                            kotItemDetails[0]?.order_item_qty
                          );
                        } else {
                          return arr[0] * kotItemDetails[0]?.order_item_qty;
                        }
                      })()
                    : 0.0}
                </td>
              </tr>
              {order_json?.charges_and_discounts?.filter((a) => a?.type === "D")
                ?.length
                ? order_json?.charges_and_discounts
                  ?.filter((a) => a?.type === "D")
                  ?.map((d) => (
                    <tr key={Math?.random()}>
                      <td style={{ fontSize: "large" }} colSpan={2}>
                        {d?.title}:
                      </td>
                      <td style={{ fontSize: "large" }}>
                        {d?.amt || d?.equivalent_amt}
                      </td>
                    </tr>
                  ))
                : ""}
              {order_json?.total_tax_gst ? (
                <>
                  <tr>
                    <td style={{ fontSize: "large" }} colSpan={2}>
                      C G S T:
                    </td>
                    <td style={{ fontSize: "large" }}>
                      {order_json?.total_tax_gst / 2}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "large" }} colSpan={2}>
                      S G S T:
                    </td>
                    <td style={{ fontSize: "large" }}>
                      {order_json?.total_tax_gst / 2}
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
              {order_json?.total_tax_vat ? (
                <tr>
                  <td style={{ fontSize: "large" }} colSpan={2}>
                    V A T:
                  </td>
                  <td style={{ fontSize: "large" }}>
                    {order_json?.total_tax_vat}
                  </td>
                </tr>
              ) : (
                ""
              )}
              {order_json?.charges_and_discounts?.filter((a) => a?.type === "C")
                ?.length
                ? order_json?.charges_and_discounts
                  ?.filter((a) => a?.type === "C")
                  ?.map((c) => (
                    <tr key={Math?.random()}>
                      <td style={{ fontSize: "large" }} colSpan={2}>
                        {c?.title}:
                      </td>
                      <td style={{ fontSize: "large" }}>
                        {c?.amt || c?.equivalent_amt}
                      </td>
                    </tr>
                  ))
                : ""}

              <tr>
                <td
                  style={{ fontSize: "large", fontWeight: "bold" }}
                  colSpan={2}
                >
                  Grand Total:
                </td>
                <td style={{ fontSize: "large", fontWeight: "bold" }}>
                  {order_json?.order_total}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <table style={{ width: "100%", borderBottom: "1px solid black" }}>
        <tr key={Math?.random()}>
          <td style={{ textAlign: "left", fontSize: "large" }}>
            {bottomNote !== "" &&
              bottomNote?.split("\n")?.map(function (item, idx) {
                return (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                );
              })}
          </td>
        </tr>
      </table>
      {couponsMessages?.map((message) => (
        <pre style={{ padding: "10px 0px", fontFamily: "auto" }}>{message}</pre>
      ))}
    </>
  );
};
